
<div class="row">
    <div class="col">
        <div class="text-center" *ngIf="spinnerGraphicAverageTimeSsta">
            <span>
                <p-progressSpinner></p-progressSpinner>
            </span>
            <br />
            <span class="text-center">Cargando...</span>
        </div>
    </div>
</div>

<div class="row" [ngClass]="{
    'd-none'  : spinnerGraphicAverageTimeSsta
}">
    <div class="col">
        <div id="chart2">
    </div>
</div>

